<template>
    <div class="blockedStep">
        <p>Cálculos avançados.</p>
        <span>Favor entrar em contato com o suporte Pentagro para mais informações.</span>
        <b-button id="next-step" :title="$t('proximo')" @click="next">
            {{ $t('proximo') }}
            <b-icon icon="arrow-right"></b-icon>
        </b-button>
    </div>
</template>

<script>
export default {
    name: "Advanced-Calc",
    props: ["next"]
}
</script>

<style scoped>
.blockedStep {
    background-color: rgba(255, 255, 255, .5);
    height: 60vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    font-size: 1.5rem;
}

.blockedStep p {
    color: #FFAA33;
    font-weight: 600;
}

.blockedStep button {
    margin-top: 1rem;
    font-size: 1.1rem;
    background-color: #ff5f00;
    border: none;
}
</style>